export default __webpack_public_path__ + "static/media/CapaLogoWhiteKo.ab185d63.svg";